/* global axios */
import ApiClient from '../ApiClient';

class PendingQuestionsAPI extends ApiClient {
  constructor() {
    super('omni/pending_questions', { accountScoped: true });
  }

  // GET /api/v1/accounts/:account_id/omni/pending_questions
  get(params = {}) {
    return axios.get(this.url, { params });
  }

  // GET /api/v1/accounts/:account_id/omni/pending_questions/:id
  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  // POST /api/v1/accounts/:account_id/omni/pending_questions
  create(data) {
    return axios.post(this.url, data);
  }

  // PATCH /api/v1/accounts/:account_id/omni/pending_questions/:id
  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  // DELETE /api/v1/accounts/:account_id/omni/pending_questions/:id
  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  // GET /api/v1/accounts/:account_id/omni/pending_questions/bots
  getBots() {
    return axios.get(`${this.url}/bots`);
  }

  // GET /api/v1/accounts/:account_id/omni/pending_questions/stats
  getStats(params = {}) {
    return axios.get(`${this.url}/stats`, { params });
  }

  // POST /api/v1/accounts/:account_id/omni/pending_questions/:id/approve
  approve(id, answer = null) {
    return axios.post(`${this.url}/${id}/approve`, { answer });
  }

  // POST /api/v1/accounts/:account_id/omni/pending_questions/:id/reject
  reject(id, reason = null) {
    return axios.post(`${this.url}/${id}/reject`, { reason });
  }
}

export default new PendingQuestionsAPI();

